// Canonical CTAs — single source of truth for every action link on the site.
// Import and use these instead of inventing new labels. Do not paraphrase.
export const CTA = {
    AUDIT:    { key: "audit",    label: "Get a free website audit",     href: "/contact?intent=audit" },
    ORDERING: { key: "ordering", label: "Start taking orders online",    href: "/contact?intent=ordering" },
    BOOKING:  { key: "booking",  label: "Set up online booking",         href: "/contact?intent=booking" },
    SEE_WORK: { key: "see_work", label: "See what we build",             href: "/case-studies" },
    CONTACT:  { key: "contact",  label: "Tell us about your business",   href: "/contact" },
};

// Map service slug → canonical CTA. Used on service detail pages.
export const CTA_FOR_SERVICE_SLUG = {
    "online-ordering-system": CTA.ORDERING,
    "online-booking-system":  CTA.BOOKING,
    "whatsapp-integration":   CTA.ORDERING,
    "app-development":        CTA.AUDIT,
    "website-development":    CTA.AUDIT,
    "ui-ux-design":           CTA.AUDIT,
    "marketing-designs":      CTA.AUDIT,
    "seo-digital-marketing":  CTA.AUDIT,
};

export function ctaForServiceSlug(slug) {
    return CTA_FOR_SERVICE_SLUG[slug] || CTA.AUDIT;
}
